import cn from "@/util/cn";
import { ComponentPropsWithoutRef, PropsWithChildren } from "react";

type ButtonVariant = "neutral" | "primary" | "danger" | "clear";

type ButtonProps = { variant: ButtonVariant } & ComponentPropsWithoutRef<"button">;

const styleForVariant = (variant: ButtonVariant) => {
  switch (variant) {
    case "neutral":
      return "text-primary/90 bg-white border border-gray-300 focus-visible:outline-gray-100 hover:bg-gray-200 disabled:bg-gray-200";
    case "primary":
      return "text-white bg-primary focus-visible:outline-primary hover:bg-primary/80 disabled:bg-primary/60";
    case "danger":
      return "text-white bg-red-600 focus-visible:outline-red-600 hover:bg-red-500 disabled:bg-gray-200 disabled:text-primary/90";
    case "clear":
      return "text-primary/90 bg-transparent focus-visible:outline-transparent hover:bg-gray-200 disabled:bg-gray-200";
  }
};

const Button = ({
  variant,
  className,
  children,
  ...otherProps
}: PropsWithChildren<ButtonProps>) => {
  const style = styleForVariant(variant);
  return (
    <button
      className={cn(
        `whitespace-nowrap flex cursor-pointer select-none items-center justify-center overflow-hidden rounded-md px-3 py-1.5 text-sm font-semibold leading-6 shadow-xs focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed disabled:opacity-50`,
        style,
        className
      )}
      {...otherProps}
    >
      {children}
    </button>
  );
};

export default Button;
